import axiosClient from "utils/api";
const URI = "/admin/plan";

export const getSubscription = async () => {
  const URL = `${URI}`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "get",
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred get Subscription :", error);
    throw error;
  }
};

export const addSubscription = async (payload) => {
  const URL = `${URI}`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "post",
      data: payload,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred add Subscription:", error);
    throw error;
  }
};

export const updateSubscription = async (payload) => {
  let { id, ...rest } = payload;
  const URL = `${URI}/${id}`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "put",
      data: rest,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred Update Subscription:", error);
    throw error;
  }
};

export const deleteSubscription = async (payload) => {
  const URL = `${URI}/${payload.id}`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "delete",
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred delete Subscription:", error);
    throw error;
  }
};

export const getAllPlanHistory = async (payload) => {
  const URL = `${URI}/subscriptions`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "get",
      params: payload,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred get Subscription :", error);
    throw error;
  }
};
